import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { theme } from '../../theme';

export const FooterWrapper = styled.footer`
  background: #0a0a15;
  border-top: 1px solid ${theme.colors.border};
  padding: 60px 0 30px;
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

export const TopRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 3rem;
  margin-bottom: 3rem;

  @media (max-width: ${theme.breakpoints.lg}) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: ${theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
  }
`;

export const BrandCol = styled.div``;

export const FooterLogo = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25rem;
  font-weight: 800;
  font-family: 'Space Grotesk', 'Manrope', sans-serif;
  letter-spacing: 0.5px;
  color: ${theme.colors.text};
  margin-bottom: 1rem;


`;

export const FooterDesc = styled.p`
  font-size: 0.85rem;
  color: ${theme.colors.textMuted};
  line-height: 1.75;
  max-width: 260px;
  margin-bottom: 1.5rem;
`;

export const SocialRow = styled.div`
  display: flex;
  gap: 0.6rem;
`;

export const SocialBtn = styled.a`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.border};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.textMuted};
  font-size: 0.9rem;
  transition: ${theme.transitions.default};

  &:hover {
    border-color: ${theme.colors.primary};
    color: ${theme.colors.primaryLight};
    background: rgba(${theme.colors.primaryRgb}, 0.1);
  }
`;

export const LinkCol = styled.div``;

export const ColTitle = styled.h4`
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${theme.colors.text};
  margin-bottom: 1.25rem;
`;

export const FooterLinks = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

export const FooterLink = styled(Link)`
  font-size: 0.85rem;
  color: ${theme.colors.textMuted};
  transition: ${theme.transitions.default};

  &:hover {
    color: ${theme.colors.primaryLight};
    padding-left: 4px;
  }
`;

export const FooterExtLink = styled.a`
  font-size: 0.85rem;
  color: ${theme.colors.textMuted};
  transition: ${theme.transitions.default};

  &:hover {
    color: ${theme.colors.primaryLight};
    padding-left: 4px;
  }
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${theme.colors.border};
  margin-bottom: 1.5rem;
`;

export const BottomRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const Copyright = styled.p`
  font-size: 0.8rem;
  color: ${theme.colors.textMuted};

  span {
    background: ${theme.colors.gradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 600;
  }
`;

export const BottomLinks = styled.div`
  display: flex;
  gap: 1.5rem;

  a {
    font-size: 0.78rem;
    color: ${theme.colors.textMuted};
    transition: ${theme.transitions.default};

    &:hover { color: ${theme.colors.primaryLight}; }
  }
`;
